import API from "../config/api.js";

export const BranchService = {
  getBranches(search = "", page = 1) {
    return API.get(`/api/branches`, { params: { search, page } });
  },
  createBranch(formData) {
    return API.post("/api/branches", formData);
  },
  getBranchById(id) {
    return API.get(`/api/branches/${id}`);
  },
  updateBranch(formData, id) {
    return API.put(`/api/branches/${id}`, formData);
  },
  deleteBranch(uuid) {
    return API.delete(`/api/branches/${uuid}`);
  },
  getAll(){
    return API.get(`/api/branches/allBranches`);
  }
};
